import { WorkingDay } from './../../models/locations/workingDay.model';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'workingDay'
})
export class WorkingDayPipe implements PipeTransform {
  transform(workingDay: WorkingDay): string {
    if (!workingDay) {
      return '';
    }
    if (
      !workingDay.start.hour &&
      !workingDay.start.minutes &&
      !workingDay.end.hour &&
      !workingDay.end.minutes
    ) {
      return 'Closed';
    }
    return `${workingDay.start.hourAsString} : ${
      workingDay.start.minutesAsString
    } - ${workingDay.end.hourAsString} : ${workingDay.end.minutesAsString}`;
  }
}
